import { render } from "./Dokumentupload.vue?vue&type=template&id=5b3a0fd0&ts=true"
import script from "./Dokumentupload.vue?vue&type=script&lang=ts"
export * from "./Dokumentupload.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__